import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { VadSubscriptionInterface } from '../models/vad-subscription.interface';

@Injectable()
export class VadSubscriptionService {

  constructor(private apiService: ApiService) {}

  /**
   * Get subscription details
   */
  getDetails(token: string): Observable<VadSubscriptionInterface> {
    return this.apiService.get<VadSubscriptionInterface>('vitrine/vad/subscription/' + token);
  }
}
